import styled from 'styled-components';

export const BackgroundModal = styled.div`
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  animation: fadeIn 0.6s;

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const RectangleContainer = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 490px;
  background: #19191b;

  border: 1px solid #282828;
  box-sizing: border-box;
`;

export const ModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  border-radius: 24px;
  width: auto;
  overflow: hidden;
  border: 1px solid #555555;
  margin: 32px 80px;

  h2 {
    font-size: 40px;
  }
`;

export const NFTImageStyled = styled.img`
  width: 100%;
`;

export const DescriptionContainer = styled.div`
  border-top: 1px solid #555555;
  width: 100%;
  background: linear-gradient(
    259.32deg,
    #19191b -30.94%,
    #252525 23.99%,
    #19191b 93.31%
  );
  padding: 17px 24px;
  box-sizing: border-box;
`;

export const SampleBadgeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
  font-family: 'MabryPro';
  font-size: 12px;
  line-height: 12px;
  text-align: right;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #555555;
`;

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-top: 16px;
  font-family: 'MabryPro';
  font-size: 14px;
  line-height: 14px;
  letter-spacing: 0.04em;
  color: #f2f2f2;
`;

export const SongNameStyled = styled.div`
  font-family: 'Recife-Display';
  font-size: 24px;
  line-height: 29px;
  margin-top: 4px;
`;

export const SongInfoContainer = styled.div`
  text-align: left;
  margin-left: 6px;
`;
export const TimeframeContainer = styled.div`
  text-align: right;
  margin-right: 6px;
`;

export const BuyButton = styled.button`
  font-family: 'MabryPro';
  font-size: 16px;
  line-height: 16px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  background: #ea6343;
  color: #fff;
  min-height: 72px;
  width: 100%;
  border: none;
  &:hover {
    cursor: pointer;
  }
`;
